import React, { useState, useEffect } from "react";
import {
    Box,
    Paper,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    IconButton,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";

import { rtdb } from "../../services/firebase";
import { ref, onValue, update } from "firebase/database";

import { Link } from "react-router-dom";
import { MdEdit, MdDelete, MdVisibility, MdVisibilityOff } from "react-icons/md";

import { FaInfoCircle } from "react-icons/fa";

export default function Products() {
    const [produtos, setProdutos] = useState([]);

    const [estoqueOpen, setEstoqueOpen] = useState(false);
    const [variacoesSelecionadas, setVariacoesSelecionadas] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [produtoParaToggle, setProdutoParaToggle] = useState(null);

    useEffect(() => {
        const productsRef = ref(rtdb, "products");

        const unsubscribe = onValue(productsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();

                // transforma objeto em array
                const lista = Object.values(data);

                setProdutos(lista);
            } else {
                setProdutos([]);
            }
        });

        return () => unsubscribe();
    }, []);

    function abrirEstoque(produto) {
        setProdutoSelecionado(produto);
        setVariacoesSelecionadas(produto.variacoes || []);
        setEstoqueOpen(true);
    }

    function abrirConfirmacao(produto) {
        setProdutoParaToggle(produto);
        setConfirmOpen(true);
    }

    async function toggleStatusProduto() {
        if (!produtoParaToggle) return;

        const novoStatus =
            produtoParaToggle.status === "active" ? "inactive" : "active";

        try {
            const produtoRef = ref(rtdb, `products/${produtoParaToggle.id}`);

            await update(produtoRef, {
                status: novoStatus
            });

            setConfirmOpen(false);
            setProdutoParaToggle(null);
        } catch (error) {
            console.error("Erro ao atualizar status:", error);
            alert("Erro ao atualizar status do produto.");
        }
    }

    return (
        <Box sx={{ p: 4, ml: 32 }}>
            {/* Cabeçalho da página */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    Produtos
                </Typography>

                <Button variant="contained" component={Link} to="/admin/produtos/novo">
                    Criar Produto
                </Button>
            </Box>

            {/* Tabela */}
            <Paper sx={{ p: 2, borderRadius: 3 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>

                                <TableCell>ID</TableCell>
                                <TableCell>Produto</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell>Preço</TableCell>
                                <TableCell>Promoção</TableCell>
                                <TableCell align="center">Ações</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {produtos.map((p) => (
                                <TableRow key={p.id} hover>
                                    <TableCell>{p.id}</TableCell>
                                    {/* IMAGEM + NOME */}
                                    <TableCell>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                            <Avatar src={p.imagens?.[0]} variant="rounded" sx={{ width: 48, height: 48 }} />
                                            <Typography sx={{ fontWeight: 600 }}>{p.nome}</Typography>
                                        </Box>
                                    </TableCell>

                                    <TableCell>{p.descricao?.substring(0, 40)}...</TableCell>

                                    <TableCell>{p.precos?.normal}</TableCell>

                                    {/* Promoção */}
                                    <TableCell>
                                        {p.precos?.isPromo ? (
                                            <Chip label="Sim" color="success" size="small" />
                                        ) : (
                                            <Chip label="Não" size="small" />
                                        )}
                                    </TableCell>

                                    {/* BOTÕES */}
                                    <TableCell align="center">
                                        <IconButton
                                            color="primary"
                                            onClick={() => abrirEstoque(p)}
                                            title="Ver Estoque"
                                        >
                                            <FaInfoCircle size={20} />

                                        </IconButton>

                                        <IconButton color="primary" component={Link} to={`/admin/editar-produto/${p.id}`}>
                                            <MdEdit size={20} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => abrirConfirmacao(p)}
                                            title={
                                                p.status === "active"
                                                    ? "Desativar produto do site"
                                                    : "Ativar produto no site"
                                            }
                                            sx={{
                                                color: p.status === "inactive" ? "error.main" : "var(--azul)"
                                            }}
                                        >
                                            {p.status === "active" ? (
                                                <MdVisibility size={20} />
                                            ) : (
                                                <MdVisibilityOff size={20} />
                                            )}
                                        </IconButton>

                                        <IconButton color="error" onClick={() => alert("Excluir produto #" + p.id)}>
                                            <MdDelete size={20} />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </Paper>

            {/* POPUP DE ESTOQUE / VARIAÇÕES */}
            <Dialog
                open={estoqueOpen}
                onClose={() => setEstoqueOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Estoque — {produtoSelecionado?.nome}
                </DialogTitle>

                <DialogContent>
                    {variacoesSelecionadas.length === 0 ? (
                        <Typography>Nenhuma variação cadastrada.</Typography>
                    ) : (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Variação</TableCell>
                                    <TableCell>Estoque</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {variacoesSelecionadas.map((v, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{v.nome}</TableCell>
                                        <TableCell>{v.quantidade}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setEstoqueOpen(false)}>Fechar</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>
                    {produtoParaToggle?.status === "active"
                        ? "Desativar produto"
                        : "Ativar produto"}
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Tem certeza que deseja{" "}
                        <strong>
                            {produtoParaToggle?.status === "active"
                                ? "desativar"
                                : "ativar"}
                        </strong>{" "}
                        o produto{" "}
                        <strong>{produtoParaToggle?.nome}</strong> no site?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>
                        Não
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={toggleStatusProduto}
                    >
                        Sim, confirmar
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>

    );
}
